import clsx from 'clsx'
import { HTMLAttributes } from 'react'

import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'
import { Heading } from '@/shared/ui/heading'
import { Icon } from '@/shared/ui/icon'

import cl from './form-status.module.scss'

const FormStatusMapping = {
	success: {
		icon: <Icon name="IPortCheckCircle" size={70} />,
		title: 'Ваша заявка отправлена',
		text: (
			<>
				В&nbsp;течение часа менеджер свяжется с&nbsp;вами. <br />
				Если вы&nbsp;оставили заявку после 21:00, то&nbsp;вам перезвонят на&nbsp;следующий день.
			</>
		),
		action: null
	},
	error: {
		icon: <Icon name="IPortErrorCircle" size={70} />,
		title: 'Не удалось отправить заявку',
		text: null,
		action: 'Попробовать еще раз'
	}
} as const

type FormStatusProps = {
	status?: 'success' | 'error'
	onRetry?: () => void
} & HTMLAttributes<HTMLDivElement>

export const FormStatus = (props: FormStatusProps) => {
	const { status, onRetry, className, ...rest } = props

	if (!status) return null

	const { icon, title, text, action } = FormStatusMapping[status]

	return (
		<div className={clsx(cl.root, className)} {...rest}>
			{icon}
			<Heading preset="h2">{title}</Heading>
			<div className={cl.content}>
				<Text size="5">{text}</Text>
				{action && (
					<Button theme="link" onClick={onRetry}>
						{action}
					</Button>
				)}
			</div>
		</div>
	)
}
